import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TaggableUser } from '../input-comment.component';
import { NgFor, NgClass } from '@angular/common';

@Component({
    selector: 'app-users-dropdown',
    templateUrl: './users-dropdown.component.html',
    styleUrls: ['./users-dropdown.component.scss'],
    standalone: true,
    imports: [NgFor, NgClass]
})
export class UsersDropdownComponent {
  filtredUsers: Array<TaggableUser>;
  // tslint:disable-next-line: variable-name
  _users: Array<TaggableUser>;
  // tslint:disable-next-line: variable-name
  _search: string;
  filterRegex: RegExp;
  selectedUser: TaggableUser = null;

  @Input() set users(users: Array<TaggableUser>) {
    this._users = users;
    this.generateFiltredUsers();
  }
  @Input() set search(search: string) {
    this._search = search;
    this.filterRegex = new RegExp(`^(${search})`, 'i');
    this.generateFiltredUsers();
  }
  @Output() chooseUser = new EventEmitter<TaggableUser>();

  constructor() { }

  private generateFiltredUsers() {
    if (!this.filterRegex) {
      this.filtredUsers = [...this._users];
      return;
    }

    this.filtredUsers = this._users.reduce<Array<TaggableUser>>((acc, currentUser) => {
      const match = this.filterRegex.exec(currentUser.name);
      if (match) {
        const foundSearch = match[1];
        const endName = currentUser.name.substring(foundSearch.length);
        acc.push({
          ...currentUser,
          name: `<span class="search-term">${foundSearch}</span>${endName}`,
        });
      }
      return acc;
    }, []);
    this.selectedUser = this.filtredUsers[0] || null;
  }

  private filterName(user: TaggableUser) {
    if (!this.filterRegex) {
      return true;
    }
    return this.filterRegex.test(user.name);
  }

  moveSelectionUp() {
    if (!this.selectedUser) {
      return;
    }
    const selectedUserIndex = this.filtredUsers.findIndex((user) => user.id === this.selectedUser.id);
    if (selectedUserIndex === -1) {
      this.selectedUser = this.filtredUsers[0] || null;
    } else if (selectedUserIndex > 0) {
      this.selectedUser = this.filtredUsers[selectedUserIndex - 1];
    }
  }

  moveSelectionDown() {
    if (!this.selectedUser) {
      return;
    }
    const selectedUserIndex = this.filtredUsers.findIndex((user) => user.id === this.selectedUser.id);
    if (selectedUserIndex === -1) {
      this.selectedUser = this.filtredUsers[0] || null;
    } else if (selectedUserIndex < this.filtredUsers.length - 1) {
      this.selectedUser = this.filtredUsers[selectedUserIndex + 1];
    }
  }

  chooseSelectedUser() {
    if (this.selectedUser) {
      const originalUser = this._users.find((user) => user.id === this.selectedUser.id);
      if (originalUser) {
        this.chooseUser.emit(originalUser);
      }
    }
  }
}
